import {ReferralManager} from '../ReferralManager';
import {ApiClientFactory, ApiClientFactoryInterface} from './clients';

export class ReferralManagerFactory {
  private readonly apiClientFactory: ApiClientFactoryInterface;

  constructor(baseUrl: string) {
    this.apiClientFactory = new ApiClientFactory(`${baseUrl}/api/v1/referral`);
  }

  public createReferralManager(token: string): ReferralManager {
    return new ReferralManager(this.apiClientFactory.createAuthorizedClient(token));
  }
}
